import { EditorContent, EditorContext, useEditor } from '@tiptap/react';
import { Image } from '@tiptap/extension-image';
import { Document } from '@tiptap/extension-document';
import { Text } from '@tiptap/extension-text';
import { Paragraph } from '@tiptap/extension-paragraph';
import { Dropcursor } from '@tiptap/extension-dropcursor';
import { TextStyle } from '@tiptap/extension-text-style';
import { Token } from './extensions/token';
import { CustomDrop } from './extensions/custom-drop';
import StarterKit from '@tiptap/starter-kit';
import { MenuBar } from './menu-bar';
import './prompt-builder.css';
import { useEffect } from 'react';

const extensions = [
  Document,
  Image.configure({
    allowBase64: true,
  }),
  Text,
  Paragraph,
  Dropcursor,
  TextStyle,
  CustomDrop,
  Token,
  StarterKit,
];

interface PromptBuilderProps {
  className?: string;
  content?: string;
  onChange?: (value: string) => void;
  outputFormat?: 'json' | 'html';
  showMenuBar?: boolean;
  readOnly?: boolean;
}

export function PromptBuilder({
  className,
  content = '',
  onChange,
  outputFormat = 'json',
  showMenuBar,
  readOnly = false,
}: PromptBuilderProps) {
  const editor = useEditor({
    editable: !readOnly,
    extensions,
    content,
    onUpdate: ({ editor }) => {
      onChange?.(
        outputFormat === 'json'
          ? JSON.stringify(editor.getJSON())
          : editor.getHTML()
      );
    },
  });

  return (
    <EditorContext.Provider value={{ editor }}>
      {showMenuBar ? <MenuBar /> : null}
      <EditorContent
        editor={editor}
        role="presentation"
        className={className}
      />
    </EditorContext.Provider>
  );
}
